import React, { useEffect, useState } from 'react'
import { InputText } from 'components/UI/InputText/InputText'
import { useInputChange } from 'hooks/useInputChange'
import { Trans } from '@lingui/macro'
import { Button } from 'components/UI/Button/Button'
import { useDispatch, useSelector } from 'react-redux'

import { NULL_VALUE, SelectBox, typeValuesListItem } from 'components/UI/SelectBox/SelectBox';
import { dOrdersSetFiltersAC } from 'model/dashboardOrders/dOrdersActionCreators';
import { IdOrdersState, typeOrdersFilters } from 'model/dashboardOrders/dOrdersReducer';
import { getTransStatus, ORDERSTATUS } from 'constants/ordersStatus';
import { IdUsersStateDataItem } from 'model/dashboardUsers/dUsersReducer';
import { getUsersList } from 'model/dashboardUsers/dUsersAPI';
import { logoutSagaAC } from 'model/system/systemActionCreators';
import { ExclamationCircleIcon } from '@heroicons/react/outline';
import { USERPOSITIONS } from 'constants/userPositions';
import { Loader } from 'components/UI/Loader/Loader';
import DateFilter from 'components/UI/DateFilter/DateFilter';

// Type
export type typeDOrdersFilters = {
    setOpenFilterBar: React.Dispatch<React.SetStateAction<boolean>>
    setIsActiveFilters: React.Dispatch<React.SetStateAction<boolean>>
}

// Component
export const DOrdersManagementFilters: React.FC<typeDOrdersFilters> = ({ setOpenFilterBar, setIsActiveFilters }) => {

    const dispatch = useDispatch()
    const filters = useSelector((state: { dOrders: IdOrdersState }) => state.dOrders.filters)

// external id input
    const {
        value: externalIdValue,
        changeValueHandler: externalIdChangeValueHandler,
        setValue: externalIdtSetValue
    } = useInputChange(filters.externalId || '')

    // Client name input
    const {
        value: clientValue,
        changeValueHandler: clientChangeValueHandler,
        setValue: clientSetValue
    } = useInputChange(filters.client || '')

    // Address input
    const {
        value: addressValue,
        changeValueHandler: addressChangeValueHandler,
        setValue: addressSetValue
    } = useInputChange(filters.address || '')

    //courier select box
    // Get list of users
    useEffect(() => {
        setLoaderCourier(true)
        const setData = async () => {

            let responseUsers = await getUsersList({
                                                       filters: {
                                                           deleted: false,
                                                           position: [ 'COURIER', 'JUNIOR_COURIER', 'DISTRIBUTOR' ],
                                                       },
                                                       full: false
                                                   }
            )

            if (responseUsers.status === 200) {
                const newManagersList: IdUsersStateDataItem[] = responseUsers.data.filter((item: IdUsersStateDataItem) => { return ( item.position === USERPOSITIONS.COURIER || item.position === USERPOSITIONS.DISTRIBUTOR || item.position === USERPOSITIONS.JUNIOR_COURIER )})

                setSelectUsersList(newManagersList)
            } else if (responseUsers.status === 401) {
                dispatch(logoutSagaAC())
            }
            setLoaderCourier(false)
        }
        setData()
        setCourierIdValue(filters.courierId ? filters!.courierId : null)
        // eslint-disable-next-line
    }, [])
    const [ courierIdValue, setCourierIdValue ] = useState<string | null>(NULL_VALUE.id)
    const [ selectUsersList, setSelectUsersList ] = useState<IdUsersStateDataItem[]>([])
    const [ loaderCourier, setLoaderCourier ] = useState(false)

    //status SelectBox
    const statusValueList: typeValuesListItem[] = [
        { id: ORDERSTATUS.CREATED, name: getTransStatus(ORDERSTATUS.CREATED) },
        // { id: ORDERSTATUS.COLLECTED, name: getTransStatus(ORDERSTATUS.COLLECTED) },
        // { id: ORDERSTATUS.COLLECTING, name: getTransStatus(ORDERSTATUS.COLLECTING) },
        { id: ORDERSTATUS.WAITING_FOR_CUSTOMER, name: getTransStatus(ORDERSTATUS.WAITING_FOR_CUSTOMER) },
        { id: ORDERSTATUS.WAITING_FOR_DELIVERY, name: getTransStatus(ORDERSTATUS.WAITING_FOR_DELIVERY) },
        { id: ORDERSTATUS.DELIVERING, name: getTransStatus(ORDERSTATUS.DELIVERING) },
        { id: ORDERSTATUS.DELIVERED_FULL, name: getTransStatus(ORDERSTATUS.DELIVERED_FULL) },
        { id: ORDERSTATUS.DELIVERED_WITH_REJECT, name: getTransStatus(ORDERSTATUS.DELIVERED_WITH_REJECT) },
        //  { id: ORDERSTATUS.REJECTED_ITEMS_RETURNED, name: getTransStatus(ORDERSTATUS.REJECTED_ITEMS_RETURNED) },
        { id: ORDERSTATUS.COMPLETE, name: getTransStatus(ORDERSTATUS.COMPLETE) },
        { id: ORDERSTATUS.CANCEL, name: getTransStatus(ORDERSTATUS.CANCEL) },
    ]
    const [ statusValue, setStatusValue ] = useState<string | null>(filters.status === null ? NULL_VALUE.id : filters.status!)

    // // saleId input
    // const {
    //     value: saleIdValue,
    //     changeValueHandler: saleIdChangeValueHandler,
    //     setValue: saleIdtSetValue
    // } = useInputChange(filters.saleId || '')

    // to Date
    const [ toValue, setToValue ] = useState(filters.dateCreated?.to ? filters.dateCreated.to.substring(0, 10) : '')


    // from Date
    const [ fromValue, setFromValue ] = useState(filters.dateCreated?.from ! ? filters.dateCreated.from.substring(0, 10) : '')


    const checkIsChangedFiltersHandler = (newFilters: typeOrdersFilters): boolean => {

        return !( newFilters.client === filters.client && newFilters.status === filters.status
            && newFilters.courierId === filters.courierId && newFilters.address === filters.address

            && newFilters.saleId === filters.saleId
            // eslint-disable-next-line eqeqeq
            && newFilters.dateCreated?.to == filters.dateCreated?.to && newFilters.dateCreated?.from == filters.dateCreated?.from
            && newFilters.externalId?.trim() === filters.externalId?.trim()
        )
    }

    const onSubmitHandler = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        let a = fromValue !== '' ? ( new Date(fromValue).toISOString() ).slice(0, 11) + '+00:00:00:00.000+00:00' : null
        let b = toValue !== '' ? ( new Date(toValue).toISOString() ).slice(0, 11) + '23:59:59:99.999+00:00' : null
        const newFilters: typeOrdersFilters = {
            client: clientValue.trim() === '' ? null : clientValue.trim(),
            address: addressValue.trim() === '' ? null : addressValue.trim(),
            courierId: courierIdValue === NULL_VALUE.id ? null : courierIdValue,
            status: statusValue === NULL_VALUE.id ? null : statusValue,
            //    saleId: saleIdValue.trim() === ''? null : saleIdValue.trim(),
            dateCreated: ( a === '' && b === '' ) ? null : {
                from: a,
                to: b
            },
            externalId: externalIdValue.trim() === '' ? null : externalIdValue.trim()
        }

        if (checkIsChangedFiltersHandler(newFilters)) {
            await dispatch(dOrdersSetFiltersAC(newFilters))
            setIsActiveFilters(true)
        }

        setOpenFilterBar(false)
    }

    const onReOrdersHandler = () => {

        clientSetValue('')
        addressSetValue('')
        // saleIdtSetValue('')
        setStatusValue(NULL_VALUE.id)
        setCourierIdValue(NULL_VALUE.id)
        setToValue('')
        setFromValue('')
        setIsActiveFilters(false)
        externalIdtSetValue('')
        dispatch(dOrdersSetFiltersAC({
                                         client: null,
                                         address: null,
                                         status: null,
                                         courierId: null,
                                         dateCreated: null,
                                         saleId: null,
                                         externalId: null
                                     }))
    }

    return (
        <>
            <form onSubmit={ (e) => onSubmitHandler(e) }>
                <div className="flex flex-col gap-4">

                    <div>
                        <InputText id="externalId" name="externalId" label={ <Trans>External order number</Trans> }
                                   value={ externalIdValue } onChange={ externalIdChangeValueHandler }
                                   maxLength={ 250 }/>
                    </div>

                    <div>
                        <InputText id="client" name="client" label={ <Trans>Client name</Trans> }
                                   value={ clientValue } onChange={ clientChangeValueHandler } maxLength={ 100 }/>
                    </div>

                    <div>
                        <InputText id="address" name="address" label={ <Trans>Destination address</Trans> }
                                   value={ addressValue } onChange={ addressChangeValueHandler } maxLength={ 100 }/>
                    </div>
                    <div className={ 'relative' }>
                        <SelectBox
                            label={ <Trans>Courier</Trans> }
                            valuesList={ selectUsersList }
                            valueId={ courierIdValue }
                            setIdValue={ setCourierIdValue }
                            labelClassname="text-left"
                        />
                        { selectUsersList.length === 0 && <div className={ 'flex mt-1 ' }>
                            <ExclamationCircleIcon className={ 'w-4 h-4 mr-1 text-red-400 ' }/>
                            <p className={ 'text-xs  text-gray-500 flex-grow' }><Trans>You have not users with position
                                'Courier'.</Trans></p>
                        </div>
                        }
                        { loaderCourier && <Loader/> }
                    </div>
                    <div>
                        <SelectBox label={ <Trans>Order status</Trans> } valuesList={ statusValueList }
                                   valueId={ statusValue } setIdValue={ setStatusValue }/>
                    </div>

                    {/*<div>*/ }
                    {/*    <InputText id="saleId" name="saleId" label={ <Trans>Sale ID:</Trans> }*/ }
                    {/*               value={ saleIdValue } onChange={ saleIdChangeValueHandler } maxLength={ 100 }/>*/ }
                    {/*</div>*/ }


                    <DateFilter
                        label={ <Trans>Creation date</Trans> }
                        fromValue={ fromValue }
                        setFromValue={ setFromValue }
                        toValue={ toValue }
                        setToValue={ setToValue }
                        maxData={ `${ ( new Date() ).getUTCFullYear() }-${ ( ( new Date() ).getUTCMonth() + 1 ) > 9 ? ( new Date() ).getUTCMonth() + 1 : '0' + ( ( new Date() ).getUTCMonth() + 1 ) }-${ ( new Date() ).getUTCDate() }` }
                        minData={ '2020-01-01' }
                    />

                    <div className="flex gap-4 mt-4">
                        <Button buttonClassName="w-full" secondary={ true } type="button"

                                label={ <Trans>Clear</Trans> }
                                onClick={ () => onReOrdersHandler() }/>
                        <Button buttonClassName="w-full" type="submit" label={ <Trans>Apply</Trans> }/>
                    </div>

                </div>
            </form>
        </>
    )
}
